import { SYSTEM_DEFAULT_FORECAST_FOLDER_ID } from "../../../constants";
import { FORECAST_SOURCE_SETTING_TYPE } from "../../../store/features";

export interface DefaultForecastSource {
  id?: string;
  forecastFolderId: FORECAST_SOURCE_SETTING_TYPE;
}

/**
 * What a user who has never set a default forecast source starts on.
 *
 * Client-side only — it carries no id, and nothing ever persists this value as-is; the
 * loader's System Default switch is what writes a durable row. That distinction is load
 * bearing: the absence of an id is how the switch tells "never set it" apart from a user
 * who deliberately picked a source (see useInitialUserContextLoader).
 *
 * System Default rather than EVA Research, so a user who has never chosen SHOWS System
 * Default from the first paint instead of only once the switch's write comes back. Seeding
 * EVA Research made the label contingent on a network round-trip: the dropdown read
 * "EVA Research" until the write landed, and stayed there for the session if it failed
 * (the write is deliberately not retried). It is safe to seed because System Default is a
 * policy, not a source — useEffectiveForecastFolderId narrows it to what the org can
 * actually query, so an org without Novi credentials still gets EVA-Research-only
 * forecasts (EVA-180).
 */
export const DEFAULT_FORECAST_SOURCE_SETTING: DefaultForecastSource = {
  forecastFolderId: SYSTEM_DEFAULT_FORECAST_FOLDER_ID
};
